<div id="contents" role="main" style="min-height: 395px;">
	<div class="progress">
		<ul>
			<li class="done"><i class="sp ico_progress1"></i><span>SELECT PRODUCT</span></li>
			<li class="active"><i class="sp ico_progress2"></i><span>INPUT PERSONAL INFORMATION</span>
			</li>
			<li><i class="sp ico_progress3"></i><span>MAKE PAYMENT</span></li>
			<li><i class="sp ico_progress4"></i><span>COMPLETE PAYMENT</span></li>
		</ul>
	</div>
	<div class="container">

		<section class="flex_bx">
			<div class="flex_bx_inner">
				<div class="sub-title"><h3>Personal Information</h3>
					<p>Please ensure your contact details are correct as these details will be used to activate Samsung Care+
						for your eligble device.</p></div>

				<form [formGroup]="form" class="form_wrap" #myForm="ngForm">
					<div class="personal-wrapper">
					<div class="form_group_col2_wrap form_name">
						<div class="form_group col2">
							<div class="tit">
								<label for="labelFirstName">First name <i class="ico_compulsory">*</i></label>
							</div>
							<div class="txt">
								<span class="inp_wrap">
									<input (keypress)="keyPressAlphaNumericSpaceOnly($event)" [value]="form.value.firstName" formControlName="firstName" type="text" remove-special-char=""
										limit-char="" limit="" id="labelFirstName" placeholder="First Name">
									<span class="focus-border"><i></i></span>
								</span>
								<span *ngIf="form.controls.firstName.dirty && form.controls.firstName.hasError('required')"
									class="warning">
									Please enter your first name.
								</span>
							</div>
						</div>
						<div class="form_group col2">
							<div class="tit">
								<label for="labelLastName">Last name <i class="ico_compulsory">*</i></label>
							</div>
							<div class="txt">
								<span class="inp_wrap">
									<input (keypress)="keyPressAlphaNumericSpaceOnly($event)" [value]="form.value.lastName" formControlName="lastName" type="text" remove-special-char=""
										limit-char="" limit="" id="labelLastName" placeholder="Last Name">
									<span class="focus-border"><i></i></span>
								</span>
								<span *ngIf="form.controls.lastName.dirty && form.controls.lastName.hasError('required')"
									class="warning">
									Please enter your last name.
								</span>
							</div>
						</div>
					</div>
					<div class="form_group">
						<div class="tit"><label for="labelAddress1">Address <i class="ico_compulsory">*</i></label></div>
						<div class="txt">
							<span class="inp_wrap">
								<input [value]="form.value.address1" formControlName="address1" type="text" id="labelAddress1"
									placeholder="address 1">
								<span class="focus-border"><i></i></span></span>
							<span *ngIf="form.controls.address1.dirty && form.controls.address1.hasError('required')"
								class="warning">Please enter a mailing address.</span>
						</div>
					</div>
					<div class="form_group">
						<div class="tit"><label for="labelAddress2">Address 2</label></div>
						<div class="txt">
							<span class="inp_wrap">
								<input [value]="form.value.address2" formControlName="address2" type="text" id="labelAddress2"
									placeholder="address 2" limit-char="" limit="50"><span class="focus-border"><i></i></span></span>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 col-xs-12">
							<div class="row">
								<div class="col-md-4 col-xs-12">
									<div class="input-wrap">
										<div class="tit"><label for="labelCity">City <i class="ico_compulsory">*</i></label></div>
										<span class="inp_wrap">
											<input (keypress)="keyPressAlphaNumericSpaceOnly($event)" [value]="form.value.locality" formControlName="locality" type="text" id="labelCity"
												placeholder="City" limit-char="" limit="50"><span class="focus-border"><i></i></span></span>
										<span *ngIf="form.controls.locality.dirty && form.controls.locality.hasError('required')"
											class="warning">Please enter a city.</span>
									</div>
								</div>
								<div class="col-md-4 col-xs-12">
									<div class="input-wrap">
										<div class="tit"><label for="labelState">State <i class="ico_compulsory">*</i></label></div>
										<span class="inp_select">
											<select formControlName="administrativeArea">
												<!-- <option [ngValue]="form.value.administrativeArea">{{getTitle(form.value.administrativeArea)}}
												</option> -->
												<option *ngFor="let state of states" [ngValue]="state.value">{{state.title}}</option>
											</select>
											<span class="focus-border"><i></i></span>
										</span>
										<span
											*ngIf="form.controls.administrativeArea.dirty && form.controls.administrativeArea.hasError('required')"
											class="warning">Please enter a state.</span>
									</div>
								</div>
								<div class="col-md-4 col-xs-12">
									<div class="input-wrap">
										<div class="tit"><label for="labelPostalCode">Billing Zip Code <i
													class="ico_compulsory">*</i></label>
										</div>
										<span class="inp_wrap">
											<input (keypress)="keyPressNumbersOnly($event)" [value]="form.value.postalCode" formControlName="postalCode" type="tel"
												id="labelPostalCode" placeholder="Billing Zip Code" minlength="5" maxlength="5">
											<span class="focus-border"><i></i></span></span>
										<span *ngIf="form.controls.postalCode.dirty && form.controls.postalCode.hasError('required')"
											class="warning">Please enter a zip code.</span>
										<span *ngIf="form.controls.postalCode.dirty && form.controls.postalCode.hasError('pattern')"
											class="warning">Zip code must contain numbers only</span>
									</div>
									<div class="row">
										<span class="notifying" style="margin-left:5px">Please ensure correct Zip Code is entered for proper
											payment processing</span>
									</div>
								</div>
								</div>
							</div>
						</div>
						<div class="col-md-12 col-xs-12">
							<div class="row">
								<div class="col-md-4">

								<!--div class="col-md-6">
									<div class="input-wrap">
										<div class="tit">Country</div>
										<span class="inp_wrap readonly">United State</span>
									</div>
								</div-->
							</div>

						</div>
					</div>
					<div class="form_group_col2_wrap form_name">
					<div class="form_group col2">
						<div class="tit"><label for="labelEmail">Email Address <i class="ico_compulsory">*</i></label></div>
						<div class="txt">
							<span class="inp_wrap">
								<input [value]="form.value.email" formControlName="email" type="text" id="labelEmail" limit-char=""
									limit="100" placeholder="Email Address">
								<span class="focus-border"><i></i></span>
							</span>
							<span *ngIf="form.controls.email.dirty && form.controls.email.hasError('required')" class="warning">Please enter your email address.</span>
							<span *ngIf="form.controls.email.dirty && form.controls.email.hasError('pattern')" class="warning">Please enter a valid email address.</span>
						</div>
					</div>
					<div class="form_group col2">
						<div class="tit clearfix">
							<label for="labelHomeUs">Phone number <i class="ico_compulsory">*</i></label>
							<!-- <span class="input_chk_basic float-right">
								<input type="checkbox" id="sameAsMobile"><label for="sameAsMobile">Same as Mobile?</label>
							</span> -->
						</div>
						<div class="txt">
							<span class="inp_wrap">
								<input (keypress)="keyPressNumbersOnly($event)" [value]="form.value.phoneNumber" (input)="formatPhoneNumber($event.target.value)"
									formControlName="phoneNumber" type="tel" id="labelHomeUs" minlength="10" maxlength="12"
									numbers-only="09" placeholder="Phone number">
								<!-- <input [value]="form.value.phoneNumber" (input)="formatPhoneNumber($event.target.value)" formControlName="phoneNumber" type="tel" id="labelHomeUs"
									limit-char="" limit="12" minlength="11" maxlength="12" numbers-only="09"
									placeholder="Phone number"> -->
								<span class="focus-border"><i></i></span>
							</span>
							<span *ngIf="form.controls.phoneNumber.dirty && form.controls.phoneNumber.hasError('required')"
								class="warning">Please enter your phone number.</span>
							<span *ngIf="form.controls.phoneNumber.dirty && form.controls.phoneNumber.hasError('pattern')"
								class="warning">Phone number must contain numbers only.</span>
						</div>
					</div></div></div>
					<!-- <div class="form_group col2">
						<div class="tit"><label for="labelTelUs">Secondary phone number</label></div>
						<div class="txt">
							<span class="inp_wrap">
								<input [value]="form.value.phoneNumber2" formControlName="phoneNumber2" type="tel" id="labelTelUs"
									limit-char="" limit="10" minlength="8" maxlength="10" numbers-only="09"
									placeholder="Secondary phone number">
								<span class="focus-border"><i></i></span></span>
							<span *ngIf="form.controls.phoneNumber2.dirty && form.controls.phoneNumber2.hasError('required')"
								class="warning">Please enter your secondary phone number.</span>
							<span *ngIf="form.controls.phoneNumber2.dirty && form.controls.phoneNumber2.hasError('pattern')"
								class="warning">Please enter numbers only</span>
						</div>
					</div> -->
					<!--
					<div class="form_group col2">
						<div class="tit">Samsung account</div>
						<div class="txt">
							<span class="inp_wrap readonly"></span>
							<span class="notifying">
								<a href="#" class="link">Sign in</a>
								with Samsung Account.
							</span>
						</div>
					</div>
					-->
					<div class="btn_area">
						<a class="btn btn_type2" (click)="onPrevious()"><img src="./assets/images/button-arrow-pre.png"> Previous</a>
						<a class="btn btn_type1" [ngClass]="{'disable': !myForm.form.valid}" (click)="onNext()">Review Order<img src="./assets/images/button-arrow.png"></a>
					</div>
				</form>
			</div>
		</section>
		<section class="flex_bx pr_sum order-summary-box">
			<div class="summary-title"><h3 class="h3">Order Summary</h3></div>
			<ul class="pr_info">
				<li class="pr_info_detail"><span class="tit">MODEL CODE</span> <span>{{product.MODELCODE}}</span></li>
				<li class="pr_info_detail"><span class="tit">SERIAL NUMBER</span> <span>{{serialNumber}}</span></li>
			</ul>

			<div class="summarty-item">
				<div class="summarty-item-left">
					<ul>
						<li><span class="care-logotype">Samsung Care+</span></li>
						<li><span class="item-title">{{product.SKUDESC}}</span></li>
						<li><span class="coverage-period">Additional {{product.TERM}}-months coverage</span></li>
					</ul>
				</div>
				<div class="summarty-item-right">
					<div>
					<span class="item-price">${{product.TECHNICIANID ? product.PRICE - product.DISCOUNTAMOUNT : product.PRICE}}</span>
					<span class="payment-frequency">{{product.PAYMENTFREQUENCY}}</span>
				</div>
					</div>
				<!--p class="notifying text-center">plus applicable sales tax</p-->
			</div>
			<div class="summarty-item">
				<div class="summarty-item-left">
					<ul>
						<li><span>Total before Tax</span></li>
						<li><span>Estimated Sales Tax</span></li>
					</ul>
				</div>
				<div class="summarty-item-right">
					<span class="item-price">${{product.TECHNICIANID ? product.PRICE - product.DISCOUNTAMOUNT : product.PRICE}}</span>
					<span>Calculated in checkout</span>
					</div>
				<!--p class="notifying text-center">plus applicable sales tax</p-->
			</div>
			<div class="total-wrapper">
				<div class="total-item">Total</div>
				<div class="total-price">${{product.TECHNICIANID ? product.PRICE - product.DISCOUNTAMOUNT : product.PRICE}}</div>
			</div>
			<p class="terms">
				By placing your order, you agree to Samsung's
				<a href="https://www.asurion.com/pdf/samsung-after-market-for-consumer-electronics/" class="link" target="_blank">Terms
					and Conditions</a> and <a href="https://www.samsung.com/us/account/privacy-policy/" class="link"
					target="_blank">Privacy Policy</a>
			</p>
		</section>

	</div>
</div>
